export * from './input-option';
export * from './event';
export * from './redux-state';
export * from './calendar-text';

// Redux classes and interfaces.
export { IFilterState } from '../redux/reducers/filter-reducer';
export { ICalendarModeState } from '../redux/reducers/calendar-mode';
export { ICalendarTextState } from '../redux/reducers/calendar-text-reducer';
export { ILazyLoaderState } from '../redux/reducers/lazy-loader-reducer';

export const transitionWidthPx = 1024;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/classes/index.ts